/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_SubtitleInputs */

const en_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask me anything about SohanScript`)
};

const ar_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسألني أي شيء عن SohanScript`)
};

const bn_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SohanScript সম্পর্কে যেকোনো কিছু জিজ্ঞেস করুন`)
};

const de_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frag mich alles über SohanScript`)
};

const es_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregúntame lo que quieras sobre SohanScript`)
};

const fr_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posez-moi vos questions sur SohanScript`)
};

const pt_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergunte o que quiser sobre o SohanScript`)
};

const zh_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向我询问有关 SohanScript 的任何问题`)
};

const tr_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bana SohanScript hakkında her şeyi sor`)
};

const ru_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спросите меня о SohanScript`)
};

const pl_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapytaj mnie o cokolwiek na temat SohanScript`)
};

/**
* | output |
* | --- |
* | "Ask me anything about SohanScript" |
*
* @param {Chat_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_subtitle = /** @type {((inputs?: Chat_SubtitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_SubtitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_subtitle(inputs)
	if (locale === "bn") return bn_chat_subtitle(inputs)
	if (locale === "de") return de_chat_subtitle(inputs)
	if (locale === "es") return es_chat_subtitle(inputs)
	if (locale === "fr") return fr_chat_subtitle(inputs)
	if (locale === "pt") return pt_chat_subtitle(inputs)
	if (locale === "zh") return zh_chat_subtitle(inputs)
	if (locale === "tr") return tr_chat_subtitle(inputs)
	if (locale === "ru") return ru_chat_subtitle(inputs)
	if (locale === "pl") return pl_chat_subtitle(inputs)
	return en_chat_subtitle(inputs)
});